import { openModal } from '@core/components/ModalStack';
import { AddWidgetOverlayProps } from './AddWidgetOverlay';

export async function openAddCourseBuilderWidgetOverlay(props: AddWidgetOverlayProps) {
  const { AddWidgetOverlay } = await import('./AddWidgetOverlay');

  openModal(AddWidgetOverlay, props);
}
